<div id="{{selectorId}}" class="digital-id-container">
    <!-- Send Verification SMS Button (shown when NOT_STARTED or FAILED) -->
    @if (showVerifyButton()) {
    <button mat-raised-button color="primary" (click)="onInitiateVerification()" [disabled]="isLoading"
        class="verify-button">
        @if (isLoading) {
        <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
        }
        @if (!isLoading) {
        <mat-icon>send</mat-icon>
        }
        {{ verificationState === 'FAILED' ? 'Resend Verification SMS' : 'Send Verification SMS' }}
    </button>
    }

    <!-- SMS Sent Message with Fallback Link (shown when SMS_SENT or IN_PROGRESS) -->
    @if (showSmsSentMessage()) {
    <div class="sms-sent-container">
        <div class="sms-icon">
            <mat-icon color="primary">sms</mat-icon>
        </div>
        
        <p class="status-message">{{ getStatusMessage() }}</p>

        <div class="fallback-section">
            <p class="fallback-text">Didn't receive the SMS?</p>
            <div class="fallback-buttons">
                <!-- Resend SMS Button -->
                <button mat-stroked-button color="primary" (click)="onInitiateVerification()" [disabled]="isLoading" class="resend-button">
                    @if (isLoading) {
                    <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
                    }
                    @if (!isLoading) {
                    <mat-icon>send</mat-icon>
                    }
                    Resend SMS
                </button>
                
                @if (verificationUrl) {
                <button mat-stroked-button (click)="openVerificationUrl()" class="fallback-button">
                    <mat-icon>open_in_new</mat-icon>
                    Open Link
                </button>
                }
            </div>
        </div>

        <div class="check-status-section">
            <button mat-stroked-button (click)="onCheckStatus()" [disabled]="isLoading" class="check-status-button">
                @if (isLoading) {
                <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
                }
                @if (!isLoading) {
                <mat-icon>refresh</mat-icon>
                }
                Check Status
            </button>
        </div>
    </div>
    }

    <!-- Success Message (shown when COMPLETED) -->
    @if (showSuccessMessage()) {
    <div class="success-container">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <p class="success-text">Verification Complete</p>
        <p class="success-subtext">{{ getStatusMessage() }}</p>
    </div>
    }
    
    <!-- Failed Message (shown when FAILED) -->
    @if (verificationState === 'FAILED') {
    <div class="failed-notice">
        <p>{{ getStatusMessage() }}</p>
    </div>
    }
</div>
